"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _renderprops = require("react-spring/renderprops");

var _samba_logo_hearth = require("../../assets/samba_logo_hearth.png");

var _samba_logo_hearth2 = _interopRequireDefault(_samba_logo_hearth);

var _Image = require("../Image");

var _Image2 = _interopRequireDefault(_Image);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Logo = require("../Logo");

var _Logo2 = _interopRequireDefault(_Logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const COLLAPSED_WIDTH = 56;
const UNCOLLAPSED_WIDTH = 240;

const COLLAPSE_DURATION = 100;
const UNCOLLAPSE_DURATION = 250;

const getTo = ({ collapsed, collapsable }) => {
  let width = UNCOLLAPSED_WIDTH;
  if (collapsable) {
    width = collapsed ? COLLAPSED_WIDTH : UNCOLLAPSED_WIDTH;
  }
  return { width };
};

const getFrom = ({ collapsed, collapsable }) => {
  let width = UNCOLLAPSED_WIDTH;
  if (collapsable) {
    width = collapsed ? UNCOLLAPSED_WIDTH : COLLAPSED_WIDTH;
  }
  return { width };
};

const getConfig = ({ collapsed }) => {
  const duration = collapsed ? UNCOLLAPSE_DURATION : COLLAPSE_DURATION;
  return { duration };
};

const Sidebar = (_ref) => {
  let { children, collapsed, collapsable } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "collapsed", "collapsable"]);

  return _react2.default.createElement(
    _renderprops.Spring,
    {
      config: getConfig({ collapsed }),
      from: getFrom({ collapsed, collapsable }),
      to: getTo({ collapsed, collapsable })
    },
    collapseProps => {
      return _react2.default.createElement(
        _Box2.default,
        _extends({}, props, { style: collapseProps }),
        _react2.default.createElement(
          _Flex2.default,
          { alignItems: "center", pl: "11px", py: 4 },
          _react2.default.createElement(_Logo2.default, { color: "pink" })
        ),
        _react2.default.createElement(
          _Box2.default,
          { py: 3 },
          _react2.default.Children.map(children, (child, index) => _react2.default.cloneElement(child, {
            collapsed: collapsed,
            collapseProps
          }))
        )
      );
    }
  );
};

Sidebar.propTypes = {
  children: _propTypes2.default.node,
  width: _propTypes2.default.number,
  collapsed: _propTypes2.default.bool,
  collapsable: _propTypes2.default.bool
};

Sidebar.defaultProps = {
  bg: "palette.ink.900",
  collapsed: false,
  collapsable: true
};

exports.default = Sidebar;